const initialState = {
  biddingStatus: '',
  bids: {},
  currentSpend: 0,
  loading: false,
  maxBids: {},
  maxSpend: 0,
  soldLots: {}
}

export default function creditLimits (state = initialState, action) {
  switch (action.type) {
    case 'USER_SPENDING_LIMIT_RESET':
      return {
        ...initialState
      }

    case 'USER_SPENDING_LIMIT_GET':
      return {
        ...state,
        loading: true
      }

    case 'USER_SPENDING_LIMIT_SUCCESS':
      return Object.assign({}, state, {
        maxSpend: action.session.maxSpend,
        currentSpend: action.session.currentSpend,
        biddingStatus: action.session.biddingStatus,
        bids: action.bids,
        maxBids: action.maxBids,
        soldLots: action.soldLots,
        loading: false
      })

    case 'USER_SESSION_CHECK_SUCCESS':
      return Object.assign({}, state, {
        ...state,
        maxSpend: action.session.maxSpend,
        biddingStatus: action.session.biddingStatus,
        loading: false
      })

    default:
      return state
  }
}
